var React = require('react');

function PipingOptions (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M67.98 16.4962L33.9698 -0.000488281L0 16.4965V52.5063L33.9927 68.1612L67.98 50.5979V16.4962ZM1.8 17.6234L33.9702 2.00031L65.0645 17.0826L63.999 17.6293L64.8208 19.2308L66.18 18.5333V49.5019L34.8701 65.6817V63.8899H33.0701V65.7546L1.8 51.3535V17.6234ZM34.8701 39.75V58.53H33.0701V39.75H34.8701ZM37.0509 33.5007L34.8701 34.6197V37.0699H33.0701V33.5201L36.2292 31.8992L37.0509 33.5007ZM62.0513 20.6605L42.6113 30.6505L41.7886 29.0496L61.2286 19.0596L62.0513 20.6605Z","fill":"#1D1D1B"}));
}

PipingOptions.defaultProps = {"width":"68","height":"69","viewBox":"0 0 68 69","fill":"none"};

module.exports = PipingOptions;

PipingOptions.default = PipingOptions;
